import { createAction, props } from '@ngrx/store';

export const dummyAction = createAction('[SaBIA] Dummy');

// #region Impact Template RELATED ACTIONS
// LOAD
export const loadImpactTemplates = createAction('[SaBIA] Load Impact Template');
export const loadImpactTemplateSuccess = createAction(
  '[SaBIA] Load Impact Template Success',
  props<{ impactTemplates: any[] }>()
);

export const updateImpactTemplate = createAction(
  '[SaBIA] Update Impact Template',
  props<{ impactTemplates: any }>()
);
export const updateImpactTemplateSuccess = createAction(
  '[SaBIA] Update Impact Template Success',
  props<{ impactTemplates: any }>()
);

//#endregion

// #region Impact Template GROUP RELATED ACTIONS
// LOAD
export const loadITGroups = createAction(
  '[SaBIA] Load Impact Template Group',
  props<{ id: number }>()
);
export const loadITGroupSuccess = createAction(
  '[SaBIA] Load Impact Template Group Success',
  props<{ iTGroups: any }>()
);

//#endregion

// #region Impact Type RELATED ACTIONS
// LOAD

export const addImpactType = createAction(
  '[SaBIA] Add Impact Type',
  props<{ impactTypes: any; templateId: number }>()
);
export const addImpactTypeSuccess = createAction(
  '[SaBIA] Add Impact Type Success',
  props<{ impactTypes: any }>()
);

//Update
export const updateImpactType = createAction(
  '[SaBIA] Update Impact Type',
  props<{ impactTypes: any }>()
);

export const updateImpactTypeSuccess = createAction(
  '[SaBIA] Update Impact Type Success',
  props<{ impactTypes: any }>()
);
//Delete
export const deleteImpactType = createAction(
  '[SaBIA] Delete Impact Type',
  props<{ impactType: any }>()
);
export const deleteImpactTypeSuccess = createAction(
  '[SaBIA] Delete Impact Type Success',
  props<{ impactType: any }>()
);

export const loadImpactTypes = createAction('[SaBIA] Load Impact Type');
export const loadImpactTypeSuccess = createAction(
  '[SaBIA] Load Impact Type Success',
  props<{ impactTypes: any[] }>()
);
//#endregion

// #region Impact Value RELATED ACTIONS
// LOAD

export const addImpactValue = createAction(
  '[SaBIA] Add Impact Value',
  props<{ impactValue: any }>()
);
export const addImpactValueSuccess = createAction(
  '[SaBIA] Add Impact Value Success',
  props<{ impactValue: any }>()
);
//Update
export const updateImpactValue = createAction(
  '[SaBIA] Update Impact Value',
  props<{ impactValue: any }>()
);
export const updateImpactValueSuccess = createAction(
  '[SaBIA] Update Impact Value Success',
  props<{ impactValue: any }>()
);
//Delete
export const deleteImpactValue = createAction(
  '[SaBIA] Delete Impact Value',
  props<{ impactValue: any }>()
);
export const deleteImpactValueSuccess = createAction(
  '[SaBIA] Delete Impact Value Success',
  props<{ impactValue: any }>()
);

export const loadImpactValues = createAction('[SaBIA] Load Impact Value');
export const loadImpactValueSuccess = createAction(
  '[SaBIA] Load Impact Value Success',
  props<{ impactValues: any[] }>()
);
//#endregion

// #region MAO RELATED ACTIONS
// LOAD
export const loadMaos = createAction('[SaBIA] Load MAO');
export const loadMaoSuccess = createAction(
  '[SaBIA] Load MAO Success',
  props<{ maos: any[] }>()
);
//ADD
export const addMaos = createAction(
  '[SaBIA] Add Maos',
  props<{ maos: any; templateId: number; rto: any }>()
);
export const addMaosSuccess = createAction(
  '[SaBIA] Add Maos Success',
  props<{ maos: any; rto: any }>()
);
//Update
export const updateMaos = createAction(
  '[SaBIA] Update Maos',
  props<{ maos: any; rto: any }>()
);
export const updateMaosSuccess = createAction(
  '[SaBIA] Update Maos Success',
  props<{ maos: any; rto: any }>()
);
//Delete
export const deleteMao = createAction(
  '[SaBIA] Delete Maos',
  props<{ mao: any }>()
);
export const deleteMaoSuccess = createAction(
  '[SaBIA] Delete Maos Success',
  props<{ mao: any }>()
);
//#endregion

//#region BIA INTERNAL RA QUESTION
export const addSaRaIntQues = createAction(
  '[SaBIA] Add Internal Ques',
  props<{ raInternalQues: any }>()
);
export const addSaRaIntQuesSuccess = createAction(
  '[SaBIA] Add Internal Ques Success',
  props<{ raInternalQues: any }>()
);
export const loadSaRaIntQues = createAction('[SaBIA] Load Internal Ques');
export const loadSaRaIntQuesSuccess = createAction(
  '[SaBIA] Load Internal Ques Success',
  props<{ raIntQues: any[] }>()
);
export const updateSaRaIntQues = createAction(
  '[SaBIA] Update Internal Ques',
  props<{ raInternalQues: any }>()
);
export const updateSaRaIntQuesSuccess = createAction(
  '[SaBIA] Update Internal Ques Success',
  props<{ raInternalQues: any }>()
);
//Delete
export const deleteSaRaIntQues = createAction(
  '[SaBIA] Delete Internal Ques',
  props<{ raInternalQues: any }>()
);
export const deleteSaRaIntQuesSuccess = createAction(
  '[SaBIA] Delete Internal Ques Success',
  props<{ raInternalQues: any }>()
);
//#endregion

//#region BIA RTO

//ADD
export const addRto = createAction(
  '[SaBIA] Add Rto',
  props<{ rtos: any; templateId: number }>()
);
export const addRtoSuccess = createAction(
  '[SaBIA] Add Rto Success',
  props<{ rtos: any }>()
);
//Update
export const updateRto = createAction(
  '[SaBIA] Update Rto',
  props<{ rtos: any }>()
);
export const updateRtoSuccess = createAction(
  '[SaBIA] Update Rto Success',
  props<{ rtos: any }>()
);
//Delete
export const deleteRto = createAction(
  '[SaBIA] Delete Rtos',
  props<{ rto: any }>()
);
export const deleteRtoSuccess = createAction(
  '[SaBIA] Delete Rtos Success',
  props<{ rto: any }>()
);
//#endregion

//#region BIA CRITICAL DEF
export const loadCriticalDef = createAction('[SaBIA] Load Critical Def');
export const loadCriticalDefSuccess = createAction(
  '[SaBIA] Load Critical Def Success',
  props<{ criticalDef: any[] }>()
);
//#endregion

// SA_BIA_INTRO
// LOAD
export const loadSaBiaIntro = createAction('[BIA SaBiaIntro] Load SaBiaIntro');
export const loadSaBiaIntroSuccess = createAction(
  '[BIA SaBiaIntro] Load SaBiaIntro Success',
  props<{ saBiaIntro: any }>()
);
// ADD BIA
export const addOrUpdateSaBiaIntro = createAction(
  '[BIA SaBiaIntro] Add or Update SaBiaIntro',
  props<{ saBiaIntro: any }>()
);
export const addOrUpdateSaBiaIntroSuccess = createAction(
  '[BIA SaBiaIntro] Add or Update SaBiaIntro Success',
  props<{ id: number; saBiaIntro: any }>()
);
